import { ColumnInterface } from '@shared/interfaces/column.interface'
import { ColumnsPostTradingAssignedEnum } from '../../enums/post-trading/columns-post-trading-assigned.enum'

export const ColumnsPostTradingAssignedConstant: ColumnInterface<ColumnsPostTradingAssignedEnum>[] = [
	{
		column: ColumnsPostTradingAssignedEnum.option,
		visible: true,
	},
	{
		column: ColumnsPostTradingAssignedEnum.options,
		visible: true,
	},
	{
		column: ColumnsPostTradingAssignedEnum.stocks,
		visible: true,
	},
	{
		column: ColumnsPostTradingAssignedEnum.sum,
		visible: true,
	},
	{
		column: ColumnsPostTradingAssignedEnum.price,
		visible: true,
	},
	{
		column: ColumnsPostTradingAssignedEnum.event,
		visible: true,
	},
	{
		column: ColumnsPostTradingAssignedEnum.date,
		visible: true,
	},
]
